<template>
	<section id="auth-container">
		<img class="back-img" src="@/assets/img/Pattern_ver_dark_blue.png" />
		<div class="auth-header logo-header">
			<img src="@/assets/img/logo-light.png" />
		</div>
		<div class="row">
			<div class="flex-center-block col-12">
				<form ref="form" class="auth-form" @submit.prevent="validate">
					<h1>Авторизация</h1>
					<div class="block-label-field">
						<label>Логин</label>
						<input type="text" v-model="login" v-on:keydown.enter="validate" />
					</div>
					<div class="block-label-field">
						<label>Пароль</label>
						<input
							:type="show ? 'text' : 'password'"
							:append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
							v-model="password"
							v-on:keydown.enter="validate"
						/>
						<a href="#" class="password-control" @click="show = !show">
							<mdicon v-if="!show" name="eye" />
							<mdicon v-else name="eye-off" />
						</a>
					</div>

					<div v-if="error" class="error-text mt-3">
						<i class="ti-info"></i>
						{{ textError }}
					</div>

					<button
						v-if="!preloader"
						class="btn btn-default"
						:disabled="!valid"
						type="submit"
					>
						Войти
					</button>
					<button v-else class="btn btn-default">
						<span class="loader loader-for-btn"></span>
					</button>
				</form>
			</div>
		</div>
	</section>

	<div
		v-if="showModalAgreement"
		class="modal-vue"
		:class="{ 'fade-in': showModalAgreement, 'fade-out': !showModalAgreement }"
	>
		<span class="container-icon" title="Закрыть" @click="closeModal">
			<mdicon name="close" width="22" height="22" />
		</span>
		<p class="modal-title">
			Подтвердите согласие с пользовательским соглашением
		</p>
		<!-- <div class="block-cb flex-center-block" @click="addField()"> -->
		<div class="block-cb flex-center-block">
			<input type="checkbox" value="1" v-model="selectedAgree" />
			<span
				>С
				<a href="http://10.51.75.2:8090/~CJwaS" target="_blank"
					>пользовательским соглашением</a
				>
				согласен</span
			>
		</div>
		<button
			v-if="!preloaderAgreement"
			class="btn btn-default"
			type="submit"
			@click="agreement()"
			v-bind:disabled="selectedAgree.length == 0"
		>
			OK
		</button>
		<button v-else class="btn btn-default">
			<span class="loader loader-for-btn"></span>
		</button>
	</div>

	<!-- Затемнение фона -->
	<div v-if="showModalAgreement" class="overlay"></div>
</template>

<script>
import GlobalRequest from '@/plugins/globalRequest'
import CryptoJS from 'crypto-js'

export default {
	name: 'AuthorizationPage',
	data() {
		return {
			showModalAgreement: false,
			selectedAgree: [1],
			preloaderAgreement: false,
			preloader: false,
			valid: true,
			login: '',
			password: '',
			show: false,
			error: false,
			textError: '',
			token: '',
			secretKey: 'H8d50Tmz3931P0aYzga702186316TBo65',
		}
	},

	mounted() {
		localStorage.removeItem('token')
		localStorage.removeItem('auth')
		localStorage.removeItem('company')
		localStorage.removeItem('email')
		localStorage.removeItem('lastAuth')
		localStorage.removeItem('partner')
		localStorage.removeItem('userID')
		localStorage.removeItem('vuex')
		localStorage.removeItem('temp')
		localStorage.removeItem('orderFields_')
	},

	methods: {
		addField() {
			console.log(this.selectedAgree)
			if (this.selectedAgree.length > 0) this.selectedAgree = []
			else this.selectedAgree.push(1)
		},

		async validate() {
			this.preloader = true
			let options = {
				login: this.login,
				password: this.password,
			}
			let dataAuth = await this.request('/login', 'POST', options)
			if (dataAuth != undefined) {
				if (dataAuth.token) {
					// Пока здесь соглашение
					this.token = dataAuth.token

					let dataAgreement = await this.request('/user/agreement', 'GET')
					console.log(dataAgreement)
					if (dataAgreement.data.id) {
						this.saveToken()
					} else {
						this.showModalAgreement = true
					}
				} else {
					this.error = true
					if (this.login == '' || this.password == '')
						this.textError = 'Заполните все поля'
					else this.textError = 'Неверный логин или пароль'
					this.preloader = false
					this.preloaderAgreement = false
				}
			} else {
				this.preloader = false
				this.preloaderAgreement = false
				this.textError = 'Ошибка при авторизации'
			}
		},

		async saveToken() {
			let authObj = {}
			authObj.login = this.login
			authObj.pass = this.password

			let encryptedObj = CryptoJS.AES.encrypt(
				JSON.stringify(authObj),
				this.secretKey
			).toString()

			let new_minut = new Date()
			new_minut.setMinutes(new_minut.getMinutes() + 30)
			document.cookie =
				'token=' + this.token + ';expires=' + new_minut.toUTCString()
			localStorage.setItem('token', JSON.stringify(this.token))
			localStorage.setItem('temp', encryptedObj)

			let res = await GlobalRequest.request('/user/profile', 'GET')
			console.log(res)
			if (res.success) {
				localStorage.setItem('partner', JSON.stringify(res.data.partner))
				localStorage.setItem('lastAuth', JSON.stringify(res.data.lastAuth))
				localStorage.setItem('email', JSON.stringify(res.data.email))
				localStorage.setItem('userID', JSON.stringify(res.data.id))
			}

			// go to order's page
			this.$router.push('/orders')
		},

		async agreement() {
			this.preloader = false
			this.preloaderAgreement = true

			let dataAgreement = await this.request('/user/agreement', 'PUT')
			if (dataAgreement.success) {
				// Сохранить данные
				this.saveToken()
				// go to order's page
				this.$router.push('/orders')
			} else {
				this.preloaderAgreement = false
				this.textError = 'Ошибка при авторизации'
			}
		},

		closeModal() {
			this.showModalAgreement = false
			this.preloader = false
			this.preloaderAgreement = false
		},

		async request(method, type, body) {
			let backURL = location.protocol + '//' + location.hostname

			if (process.env.NODE_ENV == 'development') {
				console.log('DEVELOPMENT MODE!')
				backURL = backURL + ':8081'
			}
			backURL = backURL + '/api'

			let fetchBody = {
				method: type,
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + this.token,
				},
				body: JSON.stringify(body),
				redirect: 'follow',
			}

			let query = fetch(backURL + method, fetchBody)

			return query
				.then(async response => {
					if (!response.ok) {
						return Promise.reject({
							// реджект обламывает текущий промис и передает ошибку в catch
							message:
								'На запрос ' +
								method +
								' получена ошибка ' +
								response.status +
								'. ' +
								response.statusText,
							statusCode: response.status,
							serviceAnswer: await response.json(),
						})
					}
					return Promise.resolve(response.json()).then(data => {
						return data
					})
				})
				.catch(error => {
					console.log('Ошибка при выполнении запроса')
					console.log(error)
					return error
				})
		},
	},
}
</script>
